import { render, staticRenderFns } from "./sharedContent.vue?vue&type=template&id=764c5b0a&scoped=true&"
import script from "./sharedContent.vue?vue&type=script&lang=js&"
export * from "./sharedContent.vue?vue&type=script&lang=js&"
import style0 from "./sharedContent.vue?vue&type=style&index=0&id=764c5b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c5b0a",
  null
  
)

export default component.exports